import { render, staticRenderFns } from "./overseasbasecost-setting-edit.vue?vue&type=template&id=5d9d93c8&"
import script from "./overseasbasecost-setting-edit.vue?vue&type=script&lang=ts&"
export * from "./overseasbasecost-setting-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports